export const patientDetailMenuId = "a33110e0-1522-407d-922f-c93d26db7141";
export const cumulativeProfileMenuId = "662E9057-FA87-4B18-9CB9-CED49C384A30";
export const transferOfCareRecMenuId = "E505ACC3-A7BB-479C-A238-45CADB7E3654";
export const placeHomeMedsAsOrdersMenuId = "FAA25AD2-0C5B-4292-BBB6-6B4EF32F5C92";
export const patientDetailTitle = "Patient Chart";
export const patientDetailUrl = `PatientDetail/PatientDetail.aspx?menuId=${patientDetailMenuId}&hash=0F4BE1C9DD76A57B06241911FEE0BA0150491DA2`;
export const patientListUrl = "CPOE/eMAR_PatientSearchAndList.aspx";
export const workloadMenuId = "8d2be319-92da-40f6-9c7a-efb50cc68438";
export const workloadUrl = `eMAR/eMAR_Workload.aspx?NocacheTree=Nocache&menuId=${workloadMenuId}&hash=0A8D19C7DB3F153B8EE1CECF54688A8BD671FFC1`;
export const loginUrl = "eMAR/Login.aspx?NocacheTree=56723";
export const logoutUrl = "eMAR/MCLogout.aspx?NocacheTree=Nocache";
export const notificationCenterUrl = "NotificationCenter/NotificationCenter.aspx";
export const pendingScreenUrl = "CPOE/RXVerificationOrderSelector.aspx";
export const defaultDockedTabWidth = 25;
export const messages = {
    eventNotFound: "Event not found.",
    eventCompleted: "The action has been completed.",
    dashboardInteractionFailedConsole: (message, name, payload) => `Operation not supported. ${message} Interaction name: ${name}. Interaction payload: ${JSON.stringify(payload)}.`,
    dashboardInteractionInvalidOperation: (message) => `${message} This version of the system does not support this operation. See console logs for more information.`,
    dashboardInteractionDataError: (message, name, payload) => `Operation not supported. ${message} Interaction name: ${name}. Interaction payload: ${JSON.stringify(payload)}.`,
};
export const contentTabFramePrefix = "content_tab";
export const isDevelopmentMode = typeof process === "object" && process.env?.NODE_ENV === "development";
